interface ErrorInfo {
  componentStack: string;
}

interface ErrorLogEntry {
  error: Error;
  info: ErrorInfo;
}

export default function errorHandler(error: Error, info: ErrorInfo) {
  const entry: ErrorLogEntry = {
    error,
    info,
  };

  console.error(entry);
}
